import { render, staticRenderFns } from "./AdminNoticesListView.vue?vue&type=template&id=20bf4740&scoped=true"
import script from "./AdminNoticesListView.vue?vue&type=script&lang=js"
export * from "./AdminNoticesListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf4740",
  null
  
)

export default component.exports